<template>
	<div class="navbar">
		<div class="navbar--content">
			<div class="logo-wrapper">
				<router-link to="/"
					><img src="@/assets/lucas-mccallum-logo-white.svg"
				/></router-link>
			</div>
			<div class="menu-button-wrapper">
				<button
					@click="menuToggle"
					:class="{ active: isActive }"
					class="menu-button"
				>
					<span class="default-state">
						<span></span>
						<span></span>
						<span></span>
					</span>
					<span class="active-state">
						<span></span>
						<span></span>
					</span>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'NavBar',
	data() {
		return {
			isActive: false,
		};
	},
	methods: {
		menuToggle: function () {
			// alert('running');
			this.isActive = !this.isActive;
			this.$emit('toggle-menu');
		},
	},
};
</script>

<style></style>
